import { render } from "./BlViewField.vue?vue&type=template&id=23753f63&scoped=true"
import script from "./BlViewField.vue?vue&type=script&lang=js"
export * from "./BlViewField.vue?vue&type=script&lang=js"

import "./BlViewField.vue?vue&type=style&index=0&id=23753f63&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23753f63"]])

export default __exports__